export default {
    name: 'rollCreate',

    data() {
        return {
            form: {
                roomName: '',
                desc: '',
                expirTime: null,
                type: true,
                maxUser: 0,
                password: '',
                promoteCodes: '',
                payStartTime: null,
                payEndTime: null,
                recharge: 0,
            },
        };
    },

    computed: {
        expirTimePickerOptions() {
            return {
                disabledDate(time) {
                    const today = new Date();
                    today.setHours(0, 0, 0, 0);
                    return time.getTime() < today.getTime();
                },
            };
        },
    },

    methods: {
        parseDateTime(value) {
            if (!value) return null;
            if (value instanceof Date) return value;

            const match = String(value).match(/^(\d{4})-(\d{2})-(\d{2}) (\d{2}):(\d{2}):(\d{2})$/);
            if (!match) return null;

            const year = Number(match[1]);
            const month = Number(match[2]) - 1;
            const day = Number(match[3]);
            const hour = Number(match[4]);
            const minute = Number(match[5]);
            const second = Number(match[6]);
            return new Date(year, month, day, hour, minute, second);
        },

        isExpirTimeBeforeNow(value) {
            const expirTime = this.parseDateTime(value);
            if (!expirTime) return true;

            const now = new Date();
            now.setMilliseconds(0);
            return expirTime.getTime() < now.getTime();
        },

        handleExpirTimeChange(value) {
            if (!value || !this.isExpirTimeBeforeNow(value)) return;

            this.form.expirTime = null;
            this.$toast.error('开奖时间不能早于当前时间');
        },

        handleNext() {
            const roomName = String(this.form.roomName || '').trim();
            const maxUser = Number(this.form.maxUser);

            if (!roomName) {
                return this.$toast.error('请输入房间名');
            }
            if (!this.form.expirTime) {
                return this.$toast.error('请选择开奖时间');
            }
            if (this.isExpirTimeBeforeNow(this.form.expirTime)) {
                return this.$toast.error('开奖时间不能早于当前时间');
            }
            if (!maxUser || maxUser <= 0) {
                return this.$toast.error('参与人数不能为空且必须大于0');
            }
            this.form.roomName = roomName;
            this.form.maxUser = maxUser;
            sessionStorage.setItem('rollCreateForm', JSON.stringify(this.form));
            this.$router.push({ name: 'rollCreateItems' });
        }
    }
}
